// extracted by mini-css-extract-plugin
export default {"container":"information-principal_container__v6dTh","container-signatory":"information-principal_container-signatory__nvlJg"};